import React, { FC, useState } from 'react';
import {
  BadgeGroup,
  MinDateContainer,
  // MiniBadgeItemWrapper,
  MiniContentItem,
  MiniContentText,
  MiniItemWrapper,
  MiniTaskItemBody,
  TaskBadge,
  TaskBadgeContent,
  TaskBadgePopOverTaskList,
  TaskItem,
  TaskTitle,
  TaskTitleText,
} from '../TaskListView/styles';
import {
  black,
  blue,
  gray,
  green,
  // lightGreenSolid,
  // orange,
  stringToColour,
} from '../../utils/style/colors';
import Badge from '../Badge/Badge';
import ProgressBar from '../ProgressBar';
import { languageDirection } from '../../i18n';
import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from '../../utils/number';
import { ChipContainer } from '../Chip/Chip';
import { withMutipleTitle, withTitle } from '../withTitle';
import { smartSplitDateAndTimeDuration } from '../../utils/date';
import moment from 'moment-jalaali';
// import MentionPop from '../MentionPop/MentionPop';
import {
  HiddenFieldValue,
  IField,
  ITask,
  TaskStatus,
} from '../../store/tasks/tasksType';
import APopover from '../APopover/APopover';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import taskMessages from '../../containers/Tasks/TasksManagement/Messages';
import {
  IProjectMemberView,
  IProjectStore,
} from '../../store/companies/companiesTypes';
import TaskUserList from '../UserSelector/TaskUserList';
import * as taskManipulate from '../../store/tasks/taskManipulate';
import { appDispatch, RootState } from '../../store/store';
import { markTaskAssignment, updateTask } from '../../store/tasks/tasksSlice';
import generateUserPermission from '../../utils/permission';
import { useSelector } from 'react-redux';
import {
  isCompanyAdmin,
  isCompanyOwnerOrSupport,
} from '../../store/companies/companiesUtils';
import cloneDeep from 'lodash/cloneDeep';
import { IUserOption } from '../UserSelector/UserSelector';

interface ITaskCardProps {
  task: ITask;
  companyId: string | number;
  project: IProjectStore;
  active?: boolean;
  templateSelected?: boolean;
}

const TaskCard: FC<ITaskCardProps> = ({
  task,
  companyId,
  project,
  active = false,
  templateSelected = false,
}) => {
  const { i18n, t } = useTranslation('taskManager');
  const isDarkTheme = useSelector(
    (state: RootState) => state.app.UI.themeMode === 'dark'
  );

  const thisUser = useSelector((state: RootState) => state.thisUser);
  const company = useSelector(
    (state: RootState) => state.companies.data[Number(companyId)]
  );
  const users = useSelector((state: RootState) => state.users);

  const ownerOrSupport =
    !!company && isCompanyOwnerOrSupport(thisUser, company);
  const companyAdmin = !!company && isCompanyAdmin(thisUser, company);

  const [weight, setWeight] = useState(task.weight);
  const [showWeightPopover, setShowWeightPopover] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleTaskBadge = (fieldList: IField[]) => {
    const filteredList: IField[] = fieldList.filter((field: IField) => {
      return field.options && field.value && field.value !== HiddenFieldValue;
    });
    const listedBadges = filteredList?.map((field?: IField) => {
      if (field?.options && field?.value && field?.value !== HiddenFieldValue)
        return {
          value: field.value,
          name: field.name,
        };
      else return null;
    });
    return listedBadges;
  };

  const handleSaveWeight = () => {
    const newTask = taskManipulate.storeToServer(task, true);
    setLoading(true);
    newTask.weight = weight;
    appDispatch(updateTask({ task: newTask })).then((_: any) => {
      setShowWeightPopover(false);
      setLoading(false);
    });
  };

  const handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === 'weight') {
      setWeight(Number(value));
    }
  };

  const handleAssignmentUpdate = (
    assigneeId: number,
    progress: number,
    status: TaskStatus,
    progressDescription: string,
    fieldValues: { [key: string]: string }
  ) => {
    const relatedAssignment = task.assignee[assigneeId];
    if (relatedAssignment) {
      const newRelatedAssignment = cloneDeep(relatedAssignment);
      newRelatedAssignment.status = status;
      newRelatedAssignment.progress = progress;
      newRelatedAssignment.progressDescription = progressDescription;
      newRelatedAssignment.taskFieldValues = fieldValues;
      appDispatch(markTaskAssignment({ assignment: newRelatedAssignment }));
    }
  };

  const projectMember: IProjectMemberView | undefined = project?.myMembership;

  const permission = generateUserPermission(
    Number(thisUser.userId),
    task,
    projectMember ? projectMember.canCreate : false,
    ownerOrSupport || false,
    projectMember ? projectMember.admin : false,
    companyAdmin || false
  );

  const isDeleted = task.deleteState;
  // const projectId = task.projectId;
  // const badgeColorType =
  //   (task.mentions?.length || 0) > 0
  //     ? task.mentions[0].event.type === 'CommentEvent'
  //       ? orange
  //       : blue
  //     : lightGreenSolid;
  // const projectPart =
  //   window.location.href.includes('/project/') && projectId
  //     ? `project/${projectId}/`
  //     : '';
  // const taskLink = `/t/${companyId}/${projectPart}task/editor/${task.id}/info`;
  const splitDateAndTimeDuration = smartSplitDateAndTimeDuration(
    task.startDate,
    task.dueDate,
    task.dateAndTime
  );
  // @ts-expect-error it's ok
  const overDueDate = task.dueDate! < moment().add('days', -1);
  const in24hours =
    !overDueDate &&
    // @ts-expect-error it's ok
    task.dueDate! < moment().add('days', +1) &&
    // @ts-expect-error it's ok
    task.dueDate! > moment().add('hours', -1);
  // const mentionPop = (
  //   <MentionPop
  //     mentions={task.mentions ?? []}
  //     companyId={companyId}
  //     projectId={projectId}
  //     placement={'top-start'}
  //     isHoverIcon={false}
  //   />
  // );
  let totalProgress = 0;
  if (typeof task.mainProgress === 'number') {
    totalProgress = task.mainProgress;
  } else if (typeof task.secondaryProgress === 'number') {
    totalProgress = task.secondaryProgress;
  }
  let draftMessage: string = '';
  let badgeColor: string = black;
  if (task.subTasksAreReadyToPublish) {
    badgeColor = green;
    draftMessage = taskMessages.readyPublishSubTask(
      task.readyToPublishSubTaskTitle,
      task.subTasksTitle
    );
  } else if (task.draft) {
    if (task.taskIsReadyToPublish) {
      badgeColor = green;
      draftMessage = taskMessages.readyPublishTask(
        task.readyToPublishTaskTitle,
        task.taskName
      );
    } else {
      badgeColor = '#e56a6a';
      draftMessage = t('draft', { ns: 'taskManager' });
    }
  }
  const canChangeSelfProgress = permission.markSelf && !task.draft;
  const taskWeightComponent = (
    <div>
      <APopover
        arrow={true}
        curveBorder={true}
        disabled={!permission.edit}
        placement="right-start"
        show={showWeightPopover}
        onShowChange={(show) => setShowWeightPopover(show)}
        target={
          <div>
            {withTitle(
              <Badge color="black" radius={10}>
                {convertDigitToProperFormat(task.weight)}
              </Badge>,
              t('taskWeight') + ' : ' + convertDigitToProperFormat(task.weight)
            )}
          </div>
        }
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Input
            id="weight"
            type="number"
            step="any"
            min="0"
            name="weight"
            onChange={handleChangeInput}
            value={weight}
            label={t('taskWeight', { ns: 'taskManager' })}
            placeholder={t('taskWeight', { ns: 'taskManager' })}
          />
          <div style={{ textAlign: 'center' }}>
            <Button color="green" onClick={handleSaveWeight} loading={loading}>
              {t('save', { ns: 'taskManager' })}
            </Button>
          </div>
        </div>
      </APopover>
    </div>
  );

  const assigneeValues = Object.values(task.assignee).reduce(
    (list: IUserOption[], value) => {
      const item: IUserOption = {
        userId: value.userId,
        name: users.map?.[value.userId]?.name || '',
        roles: [],
        progressDescription: value.progressDescription,
        progress: value.progress,
        optionType: 'user',
        status: value.status ? value.status : 'notStarted',
        relatedRoleId: value.properties?.roleId,
        relatedRoleName: value.properties?.roleName,
      };
      list.push(item);
      return list;
    },
    []
  );

  const progressOrAssigneePart = (
    <>
      {Object.keys(task.assignee || {}).length > 0 ? (
        <span style={{ width: '8rem' }}>
          <TaskUserList
            trigger="hover"
            type={task.type}
            onChangeProgress={handleAssignmentUpdate as any}
            task={task}
            canChangeProgress={permission.mark && !task.lockMark && !task.draft}
            canChangeSelfProgress={canChangeSelfProgress}
            compact={true}
            showTaskFields={true}
            values={assigneeValues}
            disable={true}
            disablePopover={true}
          />
        </span>
      ) : (
        <span style={{ width: '8rem' }}></span>
      )}
    </>
  );

  return (
    <>
      <MiniItemWrapper
        active={active}
        draft={task.draft}
        hasBadge={false}
        dependencyNotMeet={!!task.relatedTasks?.find((it) => it.blocksProgress)}
        isDark={isDarkTheme}
      >
        <TaskItem
          active={active}
          draft={task.draft}
          style={{ minHeight: '10rem' }}
        >
          <a style={{ flexGrow: 1 }}>
            <MiniTaskItemBody id="wrapper">
              {/* Date + Time */}
              <MiniContentItem>
                <MinDateContainer>
                  {!splitDateAndTimeDuration.date.startsWith('Unknown') && (
                    <span
                      style={{
                        cursor: 'text',
                        textAlign: 'start',
                        lineHeight: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        color: in24hours ? blue : overDueDate ? gray : black,
                      }}
                    >
                      {splitDateAndTimeDuration.date}
                    </span>
                  )}
                  {splitDateAndTimeDuration.time && (
                    <span>
                      <Badge
                        color={
                          in24hours
                            ? 'blue'
                            : overDueDate
                              ? 'lightGray'
                              : 'black'
                        }
                      >
                        {splitDateAndTimeDuration.time}
                      </Badge>
                    </span>
                  )}
                </MinDateContainer>

                {/* Progress */}
                <div
                  style={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'row-reverse',
                  }}
                >
                  <div
                    style={{
                      width: '10rem',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '0.5rem',
                    }}
                  >
                    <ProgressBar
                      count={totalProgress}
                      total={100}
                      color={`linear-gradient(to ${
                        languageDirection() === 'rtl' ? 'right' : 'left'
                      }, hsl(${totalProgress * 1.73}, 59%, 49%) 0%, var(--exact-white) 100%);`}
                    />
                    <div style={{ width: '4rem', textAlign: 'end' }}>
                      {i18n.language === 'fa'
                        ? `${convertNumbersToProperFormat(totalProgress, 0)}%`
                        : `${totalProgress.toFixed(0)}%`}
                    </div>
                  </div>
                </div>
              </MiniContentItem>

              {/* Task title */}
              <MiniContentText>
                <TaskTitle
                  deleted={isDeleted}
                  archived={task.archived || project?.archived}
                >
                  {(!templateSelected ||
                    task.draft ||
                    task.archived ||
                    task.subTasksAreReadyToPublish) && (
                    <ChipContainer
                      style={{
                        color: badgeColor,
                        backgroundColor: 'transparent',
                        flexShrink: 0,
                      }}
                      selected={false}
                    >
                      {(!templateSelected ? task.taskName || '' : '') +
                        (!templateSelected ? ' | ' : '') +
                        draftMessage +
                        (task.archived
                          ? ' | ' + t('archived')
                          : project?.archived
                            ? ' | ' + t('projectArchived')
                            : '') +
                        (task.deleteState ? ' | ' + t('deleted') : '')}
                    </ChipContainer>
                  )}
                  <TaskTitleText
                    allowedAttributes={{ span: ['style'] }}
                    allowedTags={['span']}
                    html={task.title}
                    style={{ width: '100%' }}
                  />
                </TaskTitle>
              </MiniContentText>

              {/* Badges */}
              <MiniContentItem>
                {progressOrAssigneePart}
                <BadgeGroup>
                  {handleTaskBadge(task?.fields).map((value, index, array) => {
                    if (index === 0)
                      return (
                        <TaskBadge
                          key={index}
                          size={5}
                          style={{ marginInlineEnd: 0 }}
                          radius={10}
                          color={stringToColour(
                            value!.name,
                            1,
                            null,
                            value!.value
                          )}
                        >
                          <TaskBadgeContent>{value!.value}</TaskBadgeContent>
                        </TaskBadge>
                      );
                    else if (index === 1) {
                      return withMutipleTitle(
                        <TaskBadge
                          key={index}
                          size={3}
                          style={{
                            marginInlineEnd: 0,
                            backgroundColor: `${gray}`,
                          }}
                          radius={8}
                        >
                          <TaskBadgeContent>
                            {i18n.language === 'fa'
                              ? `${convertDigitToProperFormat(array.length - 1)} +`
                              : `+ ${array.length - 1}`}
                          </TaskBadgeContent>
                        </TaskBadge>,
                        <TaskBadgePopOverTaskList>
                          {array.slice(1).map((value, index) => {
                            return (
                              <TaskBadge
                                key={index}
                                style={{ marginInlineEnd: 0 }}
                                radius={8}
                                color={stringToColour(
                                  value!.name,
                                  1,
                                  null,
                                  value!.value
                                )}
                              >
                                <TaskBadgeContent>
                                  {value!.value}
                                </TaskBadgeContent>
                              </TaskBadge>
                            );
                          })}
                        </TaskBadgePopOverTaskList>
                      );
                    }
                    return null;
                  })}
                  {task.haveWeight && taskWeightComponent}
                </BadgeGroup>
              </MiniContentItem>
            </MiniTaskItemBody>
          </a>
        </TaskItem>
      </MiniItemWrapper>
    </>
  );
};

export default TaskCard;
